<div class="content-list">
	<div class="routine-form-section">
		<entity-category
			class="category-form-field"
			[selectedCategory]="config()?.category"
			[canEditTemplate]="canEditTemplate()"
			(categoryChanged)="updateDataFn({ category: $event })"
		/>

		<entity-priority
			class="priority-form-field"
			[selectedPriority]="config()?.priority"
			[canEditTemplate]="canEditTemplate()"
			(priorityChanged)="updateDataFn({ priority: $event })"
		/>
	</div>

	<entity-schedule
		[routineTemplate]="true"
		[selectedSchedule]="{
			interval: config()?.interval,
			period: config()?.period,
			excludeWeekends: config()?.excludeWeekends,
			selectedDays: config()?.selectedDays,
			monthSetup: config()?.monthSetup,
		}"
		[canEditTemplate]="canEditTemplate()"
		(scheduleChanged)="updateDataFn($event)"
	/>

	<entity-description
		class="wide-form-field"
		[tabs]="5"
		[selectedDescription]="config()?.description"
		[canEditTemplate]="canEditTemplate()"
		(descriptionChanged)="updateDataFn({ description: $event })"
	/>

	<entity-created-by [created]="config().created" />
</div>
